<div>
  <nz-card nz-col [nzSpan]="source !== 'enrollment' ? 20 : 24" class="ppl-p24 ppl-step-main" [nzBordered]="false">
    <form nz-form [formGroup]="preferncesForm" class="ppl-p0">
      @if(isAttrAvailable('emergencyContact')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="emergencyContact"
          class="ppl-form-label">{{getAttributes('emergencyContact').label}}
          @if(getAttributes('emergencyContact').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="emergencyContactFirstName" id="emergencyContactFirstName" placeholder="First Name" [readonly]="formReadonly" 
            maxlength="20"/>
          </div>
        </nz-form-control>
        <nz-form-control class="ppl-form-control" >
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="emergencyContactLastName" id="emergencyContactLastName" placeholder="Last Name" [readonly]="formReadonly" 
            maxlength="20"/>
          </div>
        </nz-form-control>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="emergencyContactPhone" id="emergencyContactPhone"
              placeholder="Contact Number" [readonly]="formReadonly" />
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('registerPref')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="registerPref"
          class="ppl-form-label">{{getAttributes('registerPref').label}}
          @if(getAttributes('registerPref').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-col [nzSm]="8" [nzXs]="24">
          <nz-form-control class="ppl-form-control" nz-tooltip
            nzTooltipTitle="{{getAttributes('registerPref').tooltip}}" nzTooltipPlacement="topRight">
            <div [ngClass]="{ 'error': validationErrors['registerPref'] }">
              <ppl-dropdown-select
                formControlName="registerPref"
                class="ppl-select"
                id="registerPref"
                [options]="participantRegisterMode"
                [optionLabel]="'lkpValueName'"
                [optionValue]="'lkpValueCode'"
                [placeholder]="getAttributes('registerPref')?.label"
                [disabled]="formReadonly"
                aria-required="true"
                [attr.aria-label]="getAttributes('registerPref')?.label"
                [attr.aria-invalid]="validationErrors['registerPref'] ? 'true' : 'false'"
                [attr.aria-describedby]="validationErrors['registerPref'] ? 'registerPrefError' : null">
              </ppl-dropdown-select>

              @if (validationErrors['registerPref']) {
                <span id="registerPrefError" class="pl-1 error-message" role="alert">
                  {{ validationErrors['registerPref'] }}
                </span>
              }
            </div>

          </nz-form-control>
        </nz-col>
      </nz-form-item>
      }
      @if(isAttrAvailable('nonProfitStatus')){
        <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="nonProfitStatus"
            class="ppl-form-label">{{getAttributes('nonProfitStatus').label}}
            @if(getAttributes('nonProfitStatus').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }</nz-form-label>
            </nz-form-item>
        <nz-row>
            <nz-col [nzSm]="12" [nzXs]="24" >
            <nz-form-item class="ppl-form-item">
                <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="taxExempt"
                  class="ppl-form-label">{{getAttributes('taxExempt').label}}
                  @if(getAttributes('taxExempt').mandatory === 'Y'){
                  <span [attr.aria-label]="'Required'">*</span>
                  }</nz-form-label>
          <nz-form-control class="ppl-form-control">
          <div [ngClass]="{ 'error': validationErrors['taxExempt'] }">
            <ppl-dropdown-select
              formControlName="taxExempt"
              id="taxExempt"
              class="ppl-select"
              [options]="taxExemptOptions"
              [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('taxExempt').placeholder"
              [disabled]="formReadonly"
              style="width: 100%; margin-bottom: 16px;"
              aria-required="true"
              aria-describedby="taxExemptError"
              [attr.aria-label]="'Tax Exempt'"
              [attr.aria-invalid]="validationErrors['taxExempt'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['taxExempt']) {
              <span id="taxExemptError" class="pl-1 error-message" role="alert">
                {{ validationErrors['taxExempt'] }}
              </span>
            }
          </div>


          </nz-form-control>
          </nz-form-item>
          </nz-col>
          <nz-col [nzSm]="12" [nzXs]="24" >
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="nprftDocumentationReceived"
              class="ppl-form-label">{{getAttributes('nprftDocumentationReceived').label}}
              @if(getAttributes('nprftDocumentationReceived').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }</nz-form-label>
      <nz-form-control class="ppl-form-control">
        <div [ngClass]="{ 'error': validationErrors['nprftDocumentationReceived'] }">
          <ppl-dropdown-select
            formControlName="nprftDocumentationReceived"
            id="nprftDocumentationReceived"
            class="ppl-select"
            [options]="[
              { lkpValueCode: 'yes', lkpValueName: 'Yes' },
              { lkpValueCode: 'no', lkpValueName: 'No' }
            ]"
            [optionLabel]="'lkpValueName'"
            [optionValue]="'lkpValueCode'"
            [placeholder]="getAttributes('nprftDocumentationReceived').placeholder"
            [disabled]="formReadonly"
            aria-required="true"
            aria-describedby="nprftDocumentationReceivedError"
            [attr.aria-label]="'Non-profit Documentation Received'"
            [attr.aria-invalid]="validationErrors['nprftDocumentationReceived'] ? 'true' : 'false'">
          </ppl-dropdown-select>

          @if (validationErrors['nprftDocumentationReceived']) {
            <span id="nprftDocumentationReceivedError" class="pl-1 error-message" role="alert">
              {{ validationErrors['nprftDocumentationReceived'] }}
            </span>
          }
        </div>

      </nz-form-control>
      </nz-form-item>
    </nz-col>
    </nz-row>
        }
    </form>
  </nz-card>
</div>